"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.START_TRADE_ID = exports.START_OFFER_ID = void 0;
const anchor_1 = require("@project-serum/anchor");
exports.START_OFFER_ID = new anchor_1.BN(1000);
exports.START_TRADE_ID = new anchor_1.BN(1500);
